import { motion } from "framer-motion";
import { Coins, PieChart } from "lucide-react";
import { TOKENOMICS } from "@/data/site";

const colorMap = {
  gold: "text-gold border-gold/40 hover:shadow-[0_0_35px_rgba(255,215,0,0.25)]",
  ember: "text-ember border-ember/40 hover:shadow-[0_0_35px_rgba(255,69,0,0.25)]",
  blood: "text-blood border-blood/40 hover:shadow-[0_0_35px_rgba(220,38,38,0.25)]",
  solana: "text-solana border-solana/40 hover:shadow-[0_0_35px_rgba(153,69,255,0.25)]",
};

export const Tokenomics = () => {
  return (
    <section
      id="tokenomics"
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="tokenomics-section"
    >
      <div className="absolute inset-0 bg-surface/40 -z-0" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="inline-flex items-center gap-2 text-sm font-body font-bold tracking-widest uppercase text-gold mb-4">
            <PieChart className="w-4 h-4" /> The Numbers
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl uppercase text-white leading-[0.95]">
            Tokenomics That <span className="fire-gradient-text">Slap</span>
          </h2>
          <p className="mt-4 font-body text-base md:text-lg text-gray-400 max-w-2xl mx-auto">
            Fair. Transparent. Community-owned. No hidden wallets, no rug pull juice.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {TOKENOMICS.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className={`glass rounded-lg p-7 border ${colorMap[item.color]} transition-shadow duration-300`}
              data-testid={`tokenomics-card-${i}`}
            >
              <Coins className={`w-7 h-7 mb-4 ${colorMap[item.color].split(" ")[0]}`} />
              <p className="font-display text-3xl md:text-4xl text-white leading-none break-words">
                {item.value}
              </p>
              <p className="font-body font-bold text-sm text-white mt-3 uppercase tracking-wide">
                {item.label}
              </p>
              <p className="font-body text-xs text-gray-400 mt-1">{item.suffix}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
